import {
  BookingSubStatusEnum,
  BookingStatusEnum,
  SeatHoldStageEnum,
  ContractTypeEnum
} from '@kurotetsu/share/constants';

export default {
  layouts: {
    sidebar: {
      dashboard: {
        title: 'ダッシュボード'
      },
      groupManager: {
        title: '団体管理',
        notificationList: '通知一覧',
        bookingSearch: '予約一覧/検索', // 代理店、営業所、個人団体用
        groupBookingSearch: '団体予約一覧/検索', // KKT用
        periodSelect: '空席照会/新規予約',
        bulkOperation: '一斉回答',
        tourBookingList: 'ツアー情報一覧',
        restaurantBookingList: 'レストラン・食事予約一覧',
        report: '帳票データ出力'
      },
      groupSalesManager: {
        title: '団体売上管理',
        salesManager: '売上管理'
      },
      serviceManager: {
        title: '運用管理',
        trainAssignment: '車両運用確定処理',
        trainAssignmentPublic: '在庫公開管理',
        specialSeatAdjustmentSetting: '販売チャネル変更',
        suspension: '列車運休'
      },
      accountManager: {
        title: 'アカウント管理',
        operatorUserManagement: '事業者ユーザー管理',
        agencyList: '代理店一覧',
        agencyInfo: '代理店情報',
        individualGroupList: '個人団体一覧',
        individualGroupManagement: '個人団体管理',
        passwordUpdate: 'パスワード変更'
      },
      serviceInventoryManager: {
        title: '運行在庫管理',
        trainFormation: '車両造成',
        stationStopPatternSetting: '停車駅パターン設定',
        trainSchedule: 'ダイヤ時刻登録',
        calendar: '運行スケジュール計画'
      },
      masterManager: {
        title: '団体マスタ管理',
        operatorBasicInfo: '事業者情報',
        groupFareSetting: '団体料金設定',
        groupSchedule: '団体スケジュール',
        pricingPlans: '船車券設定',
        restaurant: 'レストラン設定',
        meal: '食事設定'
      },
      stationService: {
        title: '駅務管理',
        seatSearch: '空席照会/新規予約',
        bookingSearch: '個人予約一覧/検索',
        unriddenSeatRelease: '未乗車席開放',
        entryExitSummary: '入退場集計',
        gateSettings: '改札機設定',
        signageSettings: 'サイネージ設定',
        deviceMaintenance: '機器メンテナンス',
        kuronagiSeatSearch: '黒薙駅空席照会/新規予約',
        freePlan: 'フリープラン',
        couponTicket: '優待乗車券',
        report: '帳票データ出力'
      }
    }
  },
  common: {
    title: '黒部峡谷鉄道',
    welcome: 'ようこそ',
    fare: '運賃',
    amount: '金額',
    summary: '摘要',
    restaurant: 'レストラン',
    restaurantBooking: 'レストラン・食事予約',
    type: '種別',
    ticketType: '種別',
    issuer: '発行元',
    referenceMonth: '適用基準月',
    applicationBaseMonth: '適用基準月',
    rebateRate: 'リベート率（%）',
    slackPeriod: '閑散期',
    offPeak: '閑散期',
    peakPeriod: '繁忙期',
    operationPeriod: '運行期間',
    operationRoute: '運行区間',
    stationRange: '区間',
    roundTrip: '往復乗車',
    oneWayTrip: '片道乗車',
    departureStation: '乗車駅',
    arrivalStation: '下車駅',
    add: '追加',
    update: '更新',
    change: '変更',
    delete: '削除',
    search: '検索',
    action: '操作',
    cancel: 'キャンセル',
    withdrawal: '退会',
    yes: 'はい',
    no: 'いいえ',
    register: '登録',
    save: '保存',
    account: 'アカウント',
    send: '送信',
    logout: 'ログアウト',
    process: '処理',
    back: '戻る',
    create: '作成',
    detail: '詳細',
    edit: '編集', // todo: 編集と変更の違いを確認
    modify: '修正',
    copy: '複製',
    close: '閉じる',
    rescind: '取消',
    submit: '確定',
    execute: '実行',
    issue: '発行',
    reset: 'リセット',
    confirm: '確認',
    stop: '中止',
    content: '内容',
    order: '予約',
    complete: '完了',
    unset: '未設定',
    rowAdd: '行追加',
    line: '路線',
    adjust: '調整',
    email: 'メールアドレス',
    station: '駅',
    train: '列車',
    trainName: '列車名',
    serviceName: '便名',
    trainSelection: '列車選択',
    trainType: '車両種別',
    carNo: '{{carNo}}',
    carSeatCount: '{{carNo}}（{{count}}名）',
    normalCar: '普通客車',
    relaxCar: 'リラックス客車',
    direction: '方面',
    upperDirectionLabel: '宇奈月方面',
    downDirectionLabel: '欅平方面',
    up: '上り',
    down: '下り',
    weeks: ['日', '月', '火', '水', '木', '金', '土'],
    seat: '座席',
    remark: '備考',
    inventory: '在庫',
    bulkSetting: '一括設定',
    useDate: '利用日',
    tourConductor: '添乗員',
    includeTourConductor: '内、添乗員',
    contractCategoryType: '契約区分',
    selectAll: 'すべて選択/解除',
    contractType: '契約区分',
    agentName: '代理店名',
    salesOfficeName: '営業所名',
    groupType: '団体区分',
    groupName: '団体名',
    groupOrTourName: '団体名/ツアー名',
    groupOrTourNo: '予約番号/ツアー番号',
    id: 'ID',
    useTimeFromTo: '利用時間(From-To)',
    useTime: '利用時間',
    personCount: '利用人数',
    personUnit: '{{value}}人',
    personSuffix: '人',
    nameUnit: '{{value}}名',
    dayUnit: '{{day}}日',
    language: {
      ja: '日本語',
      en: 'English',
      zh: '中文'
    },
    clear: 'クリア',
    status: 'ステータス',
    subStatus: 'サブステータス',
    bookingStatus: '予約ステータス',
    bookingCreateStatus: '予約作成ステータス',
    append: '追記',
    updateBefore: '変更前',
    updateAfter: '変更後',
    searchNoResult: '検索条件に一致するデータがありません。',
    noChanges: '変更がないため、更新は行いません。',
    selected: '✔️',
    unavailable: 'ー',
    setting: '設定',
    temp: '臨時',
    next: '次へ',
    actionMessage: '{{action}}しました。',
    createSuccess: '登録しました。',
    updateSuccess: '更新しました。',
    changeSubmitSuccess: '予約変更申請を受付けました。',
    updateActionMessage: '{{name}}を更新しました。',
    updateActionFailed: '{{name}}の更新に失敗しました。',
    deleteActionMessage: '{{name}}を削除しました。',
    deleteActionFailed: '{{name}}の削除に失敗しました。',
    total: '合計',
    date: '日時',
    dateTime: '日時',
    colon: '：',
    tilde: '〜',
    slash: '/',
    number: '番号',
    whichServiceOrder: '第{{number}}希望',
    parenthesis: '（{{text}}）',
    fetchError: 'データの取得に失敗しました。',
    loading: '読み込み中...',
    noData: 'データがありません。',
    noServiceDay: '乗車日を選択してください。',
    deleteSuccess: '{{name}}を削除しました。',
    addSuccess: '{{name}}を登録しました。',
    paymentMethod: '支払方法',
    firstPaymentMethod: '初回支払方法',
    diffPaymentMethod: '差額支払方法',
    firstAndDifferencePaymentMethod: '初回支払方法/差額支払方法',
    responsibilityPassengerAmount: '責任人員相当分',
    responsibilityPassengerFare: '運賃',
    responsibilityPassengerRelaxFee: 'リラックス車両料金',
    allergyInfo: 'アレルギー情報',
    person: '名',
    toBookingConfirm: '予約内容確認へ',
    yen: '円',
    amountYen: '{{amount}}円',
    estimatedPayment: 'お支払い予定額',
    provisionalBreakdown: '仮料金内訳',
    country: '国',
    dayOfMonth: '毎月{{day}}日',
    grandTotal: '総額',
    boardingDate: '乗車日', // todo: serviceDate に統一
    serviceDate: '乗車日',
    passengerCount: '乗車人数',
    bookingNo: '予約番号',
    tourNo: 'ツアー番号',
    tourName: 'ツアー名',
    tourNameKana: 'ツアー名（ふりがな）',
    restaurantName: 'レストラン名',
    tourConductorCount: '添乗員',
    agentFee: '代理店手数料',
    cancelFee: 'キャンセル手数料',
    cancelFeeRate: 'キャンセル料率',
    paid: '支払済',
    billingAmount: '請求額',
    refundAmount: '返金額',
    firstPaymentStatus: '初回支払ステータス',
    diffPaymentStatus: '差額支払ステータス',
    ok: 'OK',
    cancelPolicy: 'キャンセルポリシー',
    cancelPolicyAgreementPrefix: '予約をするには、',
    cancelPolicyAgreementSuffix: 'に同意して頂く必要があります。',
    cancelFeeLabel: 'キャンセル料',
    autoCalc: '（自動計算）',
    editFee: '金額を編集',
    backToAutoCalc: '自動計算に戻す',
    updateBooking: '予約内容変更',
    downloadPdf: 'PDFダウンロード',
    cancelBooking: 'レストラン予約キャンセル',
    submittedDate: '申込日',
    createdDate: '登録日',
    settingDate: '設定日',
    tourInfoName: 'ツアー名',
    notification: '通知',
    fromStation: '出発駅',
    toStation: '到着駅',
    participantCount: '人数',
    participantCountUnit: '{{count}}人',
    selectAnotherServiceOrder: '第{{number}}希望を選択する',
    samePeriod: '同じ期間',
    settingPeriod: '設定期間',
    calendar: 'カレンダー',
    vehicleFee: '車両料金',
    relaxSeatAmount: 'リラックス車両料金',
    fee: '料金',
    restaurantAmount: 'レストラン料金',
    billingPayment: '請求・支払',
    bookingContent: '予約内容',
    salesAdjustment: '売上調整',
    previousParticipantCount: '変更前人数',
    currentParticipantCount: '変更後人数',
    nonBoardingParticipantCount: '不乗車人数',
    fareRefundAmount: '運賃払戻額',
    relaxSeatRefundAmount: 'リラックス車両払戻額',
    refundFee: '払戻手数料',
    refundTotalAmount: '払戻額合計',
    specialNote: '特記事項',
    notBooked: '未予約',
    monthSuffix: '月',
    yearMonthDayFormat: '{{year}}年{{month}}月{{day}}日',
    general: '一般',
    vehicle: '車両',
    notApplicable: '設定対象外',
    commonOnly: '共通のみ',
    individualSettingExists: '個別設定有り',
    applicablePeriod: '適用期間',
    trainServiceNumber: '列車番号',
    targetVehicle: '対象車両',
    applicableSeatArrangement: '適用座席配置',
    reserved: '予約済',
    availableSeats: '空席数',
    exists: 'あり',
    none: 'なし',
    noUpdateContent: '更新する内容がありません。'
  },
  share: {
    statusTypeId: {
      [BookingStatusEnum.BookingSubmitted]: '予約受付',
      [BookingStatusEnum.ChangeSubmitted]: '予約変更受付',
      [BookingStatusEnum.BookingOk]: '予約OK',
      [BookingStatusEnum.ChangeOk]: '予約変更OK',
      [BookingStatusEnum.BookingNg]: '予約NG',
      [BookingStatusEnum.ChangeNg]: '予約変更NG',
      [BookingStatusEnum.CancellationSubmitted]: 'キャンセル受付',
      [BookingStatusEnum.CancellationConfirmed]: 'キャンセル確定',
      [BookingStatusEnum.Waitlist]: 'キャンセル待ち'
    },
    statusExplanation: {
      [BookingStatusEnum.BookingSubmitted]: '代理店から予約申請を受付けた。',
      [BookingStatusEnum.ChangeSubmitted]: '代理店から予約変更申請を受付けた。',
      [BookingStatusEnum.BookingOk]:
        '予約OK（席数確保OKまたは席付OK）が確定し、代理店に予約OKを回答した。',
      [BookingStatusEnum.BookingNg]:
        '予約NG（席数確保NGまたは席付NG）が確定し、代理店に予約NGを回答した。',
      [BookingStatusEnum.ChangeOk]:
        '予約変更OK（予約変更に対して席数確保OKまたは席付OK）が確定し、代理店に予約変更OKを回答した。',
      [BookingStatusEnum.ChangeNg]:
        '予約変更NG（予約変更に対して席数確保NGまたは席付NG）が確定し、代理店に予約変更NGを回答した。',
      [BookingStatusEnum.CancellationSubmitted]:
        '代理店からキャンセル申請を受付けた。',
      [BookingStatusEnum.CancellationConfirmed]:
        '代理店がキャンセル料の支払に同意し、事業者がキャンセル確定ボタンをクリックした。',
      [BookingStatusEnum.Waitlist]:
        '代理店からキャンセル待ち申請があり、キャンセル待ちを登録した。'
    },
    subStatusTypeId: {
      [BookingSubStatusEnum.Initial]: '初期状態',
      [BookingSubStatusEnum.AllotmentConfirmed]: '席数確保OK',
      [BookingSubStatusEnum.AllotmentNotAvailable]: '席数確保NG',
      [BookingSubStatusEnum.SeatAssigning]: '席付中',
      [BookingSubStatusEnum.SeatReserved]: '席付OK',
      [BookingSubStatusEnum.SeatNotAvailable]: '席付NG',
      [BookingSubStatusEnum.SeatTableSent]: '席番表送付済'
    },
    subStatusExplanation: {
      [BookingSubStatusEnum.Initial]: 'サブステータス未確定の状態',
      [BookingSubStatusEnum.AllotmentConfirmed]:
        '席数が確保できている状態。往復の場合は両方とも席数が確保できていることを示す。',
      [BookingSubStatusEnum.AllotmentNotAvailable]:
        '席数が確保できなかった状態。通常は座席不足、任意でNGとすることも可能。',
      [BookingSubStatusEnum.SeatAssigning]:
        '席付途中の状態。往復の場合は両方とも席付けできていることを示す。',
      [BookingSubStatusEnum.SeatReserved]:
        '席付ができている状態。往復の場合は両方とも席付けできていることを示す。',
      [BookingSubStatusEnum.SeatNotAvailable]:
        '席付が出来なかった状態。団体枠開放に予約されたものに対して発生する。席数確保OKから席付を行った場合は通常発生しない。',
      [BookingSubStatusEnum.SeatTableSent]:
        '（席付OK後）席番表を送付した。往復指定の場合、両方の席番表を送付済であることを示す。'
    },
    agentContractType: {
      [ContractTypeEnum.Contracted]: '契約代理店',
      [ContractTypeEnum.NonContracted]: '非契約代理店',
      [ContractTypeEnum.Individual]: '個人'
    }
  },
  confirm: {
    title: 'ご確認ください',
    message: '{{name}}を{{action}}してもよろしいですか？',
    deleteMessage: '{{name}}を削除してもよろしいですか？',
    withdrawalMessage:
      '退会後は予約情報の参照ができなくなります。退会しますか？',
    cancelMessage: '申請を取消します。よろしいですか？',
    createMessage:
      '登録データを削除します\n削除したデータを戻すことはできません。\nよろしいでしょうか?',
    approvedConfirm:
      '申請を承認します。\n承認後の修正、削除はできません。\nよろしいでしょうか?',
    rejectReason: '申請を拒否します。\n拒否理由を入力してください。'
  },
  error: {
    systemError:
      'システムエラーが発生しました。しばらく経ってから再度お試しください。',
    dataNotFoundError: '対象データがありません。',
    lockedError:
      '他のユーザーによって更新されました。画面を再読み込みしてやり直してください。',
    invalidRequest: '操作に必要な情報を確認できませんでした。', // todo: メッセージを最適化
    unregistered: '{{name}}が登録されていません。登録してください。',
    authRequired: 'ログインが必要です。',
    authExpired: 'セッションが切れました、再度ログインしてください。',
    forbidden: 'この機能を利用する権限がありません。',
    infoMissing:
      '操作に必要な情報を確認できませんでした。前の画面に戻り、もう一度操作してください。'
  },
  creditCardPayment: {
    title: 'クレジットカード支払い',
    pay: '支払う',
    paymentAmount: '支払金額',
    cardNumber: 'カード番号',
    expire: '有効期限（YYMM）',
    securityCode: 'セキュリティコード',
    holderName: 'カード名義',
    securityNote:
      'カード情報は GMO のトークン取得にのみ使用し、本システムには保存しません。',
    success: 'クレジットカード支払いが完了しました。',
    processingTitle: 'クレジットカード支払いを確認しています。',
    processingMessage: '画面を閉じずにしばらくお待ちください。',
    successTitle: '支払いが完了しました。',
    failedTitle: '支払いを完了できませんでした。',
    backToDetail: '戻る',
    resultContextMissing:
      'クレジットカード支払い情報を確認できませんでした。売上詳細から再度お試しください。',
    failed:
      'クレジットカード支払いに失敗しました。しばらく後に再試行してください。'
  },
  views: {
    bookingCancel: {
      prompt: '下記の予約を解約（払戻）しますか？',
      responsibleCount: '責任人員',
      fareCancelFee: '運賃キャンセル料',
      relaxCancelFee: 'リラックス車両キャンセル料',
      requestAction: 'キャンセルを申請する',
      confirmAction: 'キャンセルを確定する',
      requestAccepted: 'キャンセル申請を受け付けました。',
      confirmAccepted: 'キャンセル確定を受け付けました。',
      dialogMessage:
        'キャンセルチャージ料金{{amount}}です。\n弊社が承諾して、はじめて取消完了となります。\nキャンセル実行後の操作取消できません。',
      ticketRebate: '船車券（{{name}}）',
      ticketRebateWithPayment: '船車券（{{name}}）/{{paymentMethod}}',
      settlementStatus: {
        NOT_STARTED: '未開始',
        NOT_REQUIRED: '精算不要',
        PENDING: '精算処理待ち',
        PROCESSING: '精算処理中',
        SUCCEEDED: '精算完了',
        FAILED: '精算失敗（運営への確認が必要です）',
        ACTION_REQUIRED: '追加のお支払いまたは運営による対応が必要です。'
      }
    },
    calendar: {
      yearMonth: '{{year}}年{{month}}月'
    },
    inventory: {
      title: '枠調整',
      emptyService: '列車を選択してください。',
      noData: '枠調整対象の座席情報がありません。',
      tips: '枠を調整するには、席種別を選択してから座席をクリックしてください。予約済または受付不可の座席は変更できません。',
      updateSuccess: '枠調整を更新しました。',
      noAdjustmentType: '席種別が取得できませんでした。'
    },
    tourBooking: {
      addAnotherServiceOrder: '第{{number}}希望を追加する',
      samePeriod: '（同じ期間）',
      list: {
        title: 'ツアー情報一覧',
        dateRangeError: '開始日は終了日より前にしてください。',
        dateRangeErrorTo: '終了日は開始日より後にしてください。'
      },
      detail: {
        title: 'ツアー情報',
        bookingCreateLabel: 'ツアー予約作成:',
        notCreated: '未作成',
        created: '作成済',
        updateTourInfo: 'ツアー情報変更',
        createTourBookingSuccess:
          'ツアー予約作成を実行しました。処理結果はメールで送付します。受信後に内容を確認してください。',
        jobResult: 'ツアー予約作成結果',
        jobSummary:
          '成功: {{success}}件 / スキップ: {{skip}}件 / エラー: {{error}}件',
        jobErrors: 'エラー詳細'
      },
      periodSelect: {
        title: 'ツアー情報登録（期間選択）',
        sectionTitle: '検索期間選択'
      },
      routeSelect: {
        title: 'ツアー情報登録（区間選択）'
      },
      trainSelect: {
        title: 'ツアー情報登録（列車選択）',
        periodSuffix: 'の列車'
      },
      create: {
        title: 'ツアー情報登録',
        goToConfirm: '予約確認画面へ',
        calendarRequired: '日付を選択してください。',
        success: '登録しました。',
        confirmDialogTitle: 'ツアー予約作成',
        restaurantNoticeTitle: 'レストラン・食事予約について',
        restaurantNoticeMessage:
          'レストラン・食事を予約する場合は、ツアー情報作成前にツアー情報詳細画面から登録してください。'
      },
      update: {
        title: 'ツアー情報変更'
      }
    },
    restaurantBooking: {
      list: {
        title: 'レストラン食事予約一覧',
        statusReception: '予約受付',
        statusConfirmed: '予約確定',
        dateRangeError: '開始日は終了日より前にしてください。',
        dateRangeErrorTo: '終了日は開始日より後にしてください。'
      },
      create: {
        title: 'レストラン・食事新規予約'
      },
      update: {
        title: 'レストラン・食事予約変更'
      },
      updateConfirm: {
        title: 'レストラン・食事予約変更内容確認',
        submitBooking: '変更を申し込む'
      },
      detail: {
        manualCalc: '（手動計算）',
        amountRequired: '金額を入力してください。',
        agentFeeUpdated: '代理店手数料を更新しました。',
        cancelFeeUpdated: 'キャンセル手数料を更新しました。',
        noRestaurantTime:
          '団体予約の変更に伴うレストラン予約変更が承れません。レストラン予約をキャンセルしてください。',
        tourApplyWarning:
          'ツアー情報詳細画面の作成/更新ボタンを押下して、レストラン・食事予約内容を反映してください。',

        title: 'レストラン・食事予約詳細',
        tabs: {
          bookingContent: '予約内容',
          changeHistory: '変更履歴'
        },
        historyTable: {
          date: '日付',
          pageDetail: 'ページ詳細'
        },
        cancelPolicyNote:
          '【キャンセル料】\nお客様のご都合でキャンセルされる場合、キャンセル料が発生します。',
        cancelPolicy3DaysBefore: '利用日の3日前まで',
        cancelPolicyFree: '0%（無料）',
        cancelPolicy2DaysBefore: '利用日の2日前から当日',
        cancelPolicy100: '100%',
        cancelPolicyNoContact:
          '● ご連絡をいただかない場合のキャンセルは、ご予約いただいた料金の100%をご請求させていただきます。',
        cancelDialog: {
          title: '予約をキャンセルしますか？',
          messagePrefix: '予約キャンセルには、',
          cancelPolicyLink: 'キャンセルポリシー',
          messageSuffix: 'に同意して頂く必要があります。',
          abort: '中止',
          confirm: '確定'
        }
      },
      confirm: {
        title: 'レストラン・食事予約内容確認',
        totalMealCount: '合計食数',
        tourConductorNote:
          '※添乗員分はお支払い予定額に含まれません。別途、現地での精算が必要です。',
        cancelPolicyPrefix: '予約をするには、',
        cancelPolicyLink: 'キャンセルポリシー',
        cancelPolicySuffix: 'に同意して頂く必要があります。',
        submitBooking: '予約を申し込む'
      },
      cancel: {
        title: 'レストラン・食事予約キャンセル',
        totalLabel: '合計 {{amount}}円',
        mealTotal: '食事総額',
        submit: 'キャンセルを確定する'
      },
      form: {
        bookingInfo: {
          sectionTitle: '予約情報',
          groupName: '団体名/ツアー名'
        },
        restaurantInfo: {
          sectionTitle: 'レストラン情報',
          includeTourConductor: '（内、添乗員',
          tourConductorCountThanPersonCount: '添乗員人数は利用人数',
          editTrainTimeWarning: '欅平発の列車乗車時間にご注意ください',
          changeUseDateTime: '利用日時を変更してください。',
          useDateNotInPeriod:
            '選択した利用日はレストランの利用期間内ではありません。',
          useDateBookingUnavailable:
            'ご利用日の予約が受け付けられません。前の画面へ戻ってください。',
          allTimeSlotsUnavailable:
            '予約可能な時間帯がありません。前の画面へ戻ってください。'
        },
        mealInfo: {
          sectionTitle: '食事情報',
          remainingCount: '残り食数',
          soldCount: '販売食数',
          mealContent: '食事情報',
          mealName: '食事名',
          price: '価格（税込）',
          count: '食数',
          groupCount: '団体分',
          tourConductorCount: '添乗員分',
          tourConductorCountThanPersonCount: '添乗員分は団体分'
        },
        allergyInfo: {
          sectionTitle: 'アレルギー情報',
          notice1: 'アレルギーをお持ちの方の情報を入力してください。',
          notice2:
            '内容を確認のうえ、食堂担当者より予約担当者様へご連絡させていただきます。',
          placeholder1: '記入例',
          placeholder2: '予約担当者氏名、予約担当者連絡先（電話番号）',
          placeholder3: '1人目・・・〇〇と〇〇NG、2人目・・・〇〇NG',
          footNote1:
            '※ 当該欄はアレルギーの通知欄であり、問い合わせ欄ではございません。',
          footNote2: '※ 代替メニューの指定はできません。'
        },
        paymentMethod: {
          sectionTitle: '支払方法'
        },
        validation: {
          exceedsParticipantCount: '乗車人数を超える予約はできません。',
          exceedsRemainingMealCount: '残り食数を超える予約はできません。',
          exceedsUsePersonCount: '利用人数を超える予約はできません。',
          mealCountMinimum: '食事数は1食以上を入力してください。',
          mealCountNotMatchPersonCount:
            '利用人数と合わせて食事人数を入力してください。'
        }
      },
      historyDetail: {
        titleSuffix: '内容確認'
      }
    },
    salesManager: {
      list: {
        title: '売上管理'
      },
      detail: {
        title: '請求・支払',
        fareSectionTitle: '運賃・リラックス車両料金請求・支払',
        restaurantSectionTitle: 'レストラン請求・支払',
        totalAmount: '支払総額',
        initialPayment: '初回支払',
        differencePayment: '差額支払',
        amount: '支払額',
        paymentStatus: '支払STS',
        invoice: '請求書',
        receipt: '領収書',
        pay: '支払',
        rebatePaymentMethod: 'リベート支払方法',
        refundAmount: '返金額',
        statement: '明細書',
        noPayment: '支払なし'
      },
      salesAdjustment: {
        title: '売上調整',
        bookingNo: '予約番号',
        adjustmentContent: '調整内容',
        bookingData: '予約データ',
        adjustmentAmount: '調整額',
        fare: '運賃',
        relaxSeatFee: 'リラックス車両料金',
        responsibilityPassenger: '責任人員相当分',
        fee: '料金',
        restaurantFee: 'レストラン料金'
      },
      farePaymentStatus: '運賃・車両支払STS',
      restaurantPaymentStatus: 'レストラン支払STS',
      adjustmentPresence: '調整',
      statusShort: '予約STS',
      ticketVouchPayment: {
        title: '船車券/業務用クーポン発行',
        notice1:
          '業務用クーポンは当社と契約のある企業様にて発行されたクーポンのみご利用可能です。',
        notece1_1: '契約外のクーポンは使用できません。',
        notice2: '業務用クーポンには、観光券、食事券が含まれます。',
        ticketVouchCouponType: '船車券/クーポン券種',
        ticketVouchCouponTypePlaceholder:
          '船車券/クーポン券の券種を選択してください。',
        ticketVouchCouponNumber: '船車券/クーポン番号',
        ticketVouchCouponNumberPlaceholder:
          '発行された船車券/クーポン券番号を入力してください。',
        ticketVouchCouponIssueDate: '船車券/クーポン発行日',
        ticketVouchCouponIssueDatePlaceholder:
          '船車券/クーポン券が発行された日を選択してください。',
        ticketVouchCouponParticipantCount: '船車券/クーポン人数',
        ticketVouchCouponParticipantCountPlaceholder:
          '船車券/クーポン券に記載された人数を入力してください。',
        ticketVouchCouponAmount: '船車券/クーポン金額',
        ticketVouchCouponAmountPlaceholder:
          '船車券/クーポン券に記載された金額を入力してください。',
        executePayment: '支払実行',
        executeProvisionalPayment: '仮払い実行'
      },
      nonBoardingCertificateIssue: {
        title: '不乗証明書発行',
        adult: 'おとな',
        child: 'こども',
        certificateIssue: '不乗証明書発行'
      }
    },
    booking: {
      calendar: {
        periodError: '運行期間を取得できませんでした。再読込してください。',
        stationError: '駅情報を取得できませんでした。再読込してください。',
        unavailable:
          '選択された運行期間は利用できません。運行期間を選択し直してください。'
      },
      periodSelect: {
        title: '空席照会/新規予約',
        sectionTitle: '検索期間選択',
        reload: '再読込'
      },
      byDate: {
        invalidContext:
          '乗車日・区間または希望の情報が正しくありません。前の画面から選択し直してください。',
        title: '空席照会/新規予約',
        bookingListTitle: '受付リスト：事業者',
        bookingStatus: '{{date}}の予約状況',
        groupSeats: '団体席数',
        normalCar: '普通客車',
        relaxCar: 'リラックス客車',
        seatAvailability: '空席状況',
        trainSelection: '列車選択',
        goToCreate: '予約内容入力へ',
        goToUpdate: '予約変更画面へ',
        downDirection: '【下り】{{fromStationLabel}}→{{toStationLabel}}',
        upDirection: '【上り】{{fromStationLabel}}→{{toStationLabel}}',
        suspended: '運休',
        noFoldbackService: '折返列車がありません。',
        disabledReasons: {
          BEFORE_CONNECTION_THRESHOLD: '接続不可',
          AUTO_SELECTED: '自動選択',
          FOLDBACK_AUTO_SELECTION: '折返自動選択'
        },
        hasBooking: '予約あり',
        groupArrangementInsufficient: '団体席不足',
        hasWaitlist: 'キャンセル待ちあり',
        colBookingNoAndTourNo: '予約番号・ツアー番号',
        colSubmittedDate: '申込日',
        colServiceDate: '乗車日',
        colTrainName: '便名',
        colSeatType: '車両種別',
        colSection: '区間',
        colParticipants: '人数',
        colGroupOrTourName: '団体名/ツアー名',
        colAgentName: '代理店名',
        colSalesOfficeName: '営業所名',
        colHandClose: '手仕舞',
        colEnsureSeats: '席確保',
        colBookingDetail: '予約内容',
        ensureSeatsBtn: '席確保',
        seatAdjustment: '枠調整',
        suspensionNotice: '運休連絡',
        bulkCancel: '一括キャンセル',
        reservedSeats: '確保済席数',
        totalRequiredSeats: '合計必要数',
        remainingSeats: '残数',
        confirmedList: '確定リスト',
        autoAssign: '自動席付',
        autoAssignDialog: {
          title: '自動席付を実行します',
          message: '席付を行う方向を選択してください。',
          forward: '列車前方から',
          backward: '列車後方から',
          execute: '実行'
        },
        receptionList: '受付リスト',
        confirmAll: '一斉確定',
        cancellationReceptionList: 'キャンセル受付リスト',
        autoAssignResult: {
          label: '自動席付結果',
          summary: '成功：{{successCount}}件 ／ 失敗：{{failureCount}}件',
          failedBookingNo: '失敗した予約番号：{{bookingNo}}',
          bookingNo: '予約番号',
          result: '結果',
          reason: '理由',
          success: '成功',
          failure: '失敗',
          unprocessed: '失敗した予約以降は未処理です。'
        },
        success: {
          confirmAll: '一斉確定が完了しました。',
          autoAssign: '自動席付が完了しました。',
          suspensionNotice: '運休連絡が完了しました。',
          bulkCancel: '一括キャンセルが完了しました。'
        },
        error: {
          autoAssignFailed: '自動席付ができませんでした。{{bookingNumbers}}',
          nonProcessTargetSelected: '処理対象外の予約が選択されています。',
          bookingVersionChanged:
            '選択した予約の更新情報を確認できません。画面を再読み込みしてから、もう一度選択してください。'
        }
      },
      searchAllotmentsCreateTitle: '空席照会/新規予約',
      searchAllotmentsUpdateTitle: '乗車日の変更',
      yymm: '指定日時',
      yearSuffix: '年',
      monthLabel: '{{which}}月',
      yearLabel: '{{which}}年',
      seatPickTips: 'ご希望のお日にち（「○」「△」「×」）を選択してください。',
      seatSufficientLegend: '空席あり',
      seatFewLegend: '空席わずか',
      seatSoldoutLegend: '残席なし',
      // Booking common
      scheduledPayment: 'お支払い予定額',
      totalPayment: '合計 {{totalPrice}}円',
      totalPaymentText: '',
      totalPaymentPrice: '{{totalPrice}}円',
      totalPaymentNote:
        '※金額は責任人員での料金です。責任人員でのお支払いとなります。',
      needChair: '車椅子席をご利用の方',
      fare: '運賃',
      reductionQuantity: '減員数',
      reductionHandleCharge: '減員手数料',
      totalFare: '運賃合計',
      decrementFeeTotal: '減員手数料合計',
      totalAmount: '合計',
      cancelFeeTotal: '取消手数料合計',
      passengerCount: '乗車人数',
      fareBreakdown: '料金内訳',
      wheelChairUse: '車椅子利用',
      wheelChairInfo: 'ご利用台数{{total}}台（スロープ利用{{needSlope}}台）',
      handClosePassengerCount: '手仕舞時人数',
      responsiblePerson: '責任人員',
      unitAnnotation: {
        NORMAL: '一般',
        HANDICAPPED_1: '障害者1',
        HANDICAPPED_2: '障害者2',
        SUPPORTER: '介助者',
        FREE: '無料'
      },
      fareType: {
        adult: '大人',
        child: '小人'
      },
      groupTypeLabel: '団体区分',
      groupType: {
        normal: '一般団体',
        school: '学校団体'
      },
      participantCount: '人数',
      confirmed: '確定',
      totalParticipantCount: '人数合計',
      participantNote:
        '*幼児のお子様は無賃の場合、座席のご用意がございません。恐れ入りますが、お席をご利用の場合は有料でのご案内となります。その際は、「こども」の項目に人数を入れてください。',
      submittedAt: '申込日',
      bookingId: '予約番号',
      tourInfoNo: 'ツアー番号',
      groupName: '団体名',
      groupNameKana: '団体名（ふりがな）',
      agentNameForIndividual: '団体名',
      agentNameKanaForIndividual: '団体名（ふりがな）',
      country: '国',
      prefecture: 'ご利用者都道府県',
      applicantName: '申込者氏名',
      applicantPhoneNumber: '申込者連絡先',
      applicantEmail: '申込者メール',
      tourConductorName: '添乗員・代表者氏名',
      tourConductorPhoneNumber: '添乗員・代表者連絡先',
      note: 'メモ',
      remark: 'メモ',
      operatorName: '担当者',
      waitListing: 'キャンセル待ち',
      applyWaitlist: '申し込む',
      notApplyWaitlist: '申し込まない',
      contractType: '契約区分',
      agentType: '代理店種別',
      agentName: '代理店名',
      agentSubGroupName: '営業所名',
      wheelChairCount: '車椅子{{count}}台',
      wheelChairNumber: '{{number}}台目',
      needSlope: 'スロープ利用',
      wheelChairNote:
        '※車いす固定スペースは、車いすのままご乗車できるスペースとなっております。座席ではございません。\n  また、車いす固定スペースは1席のみのご用意の為、お申し込みのタイミングによっては満席の場合もございます。何卒ご了承ください。',
      wishWaitlist: '希望する',
      sameDay: '（同じ日）',
      fromCalendar: '（カレンダーから選ぶ）',
      cancellationPolicy: 'キャンセルポリシー',
      requestBooking: 'リクエスト予約する',
      // BookingCreate
      createTitle: '新規予約',
      copyTitle: '予約の複製',
      selectAnotherServiceOrder: '第{{number}}便を選択',
      goToConfirm: '予約確認へ',
      // BookingUpdate
      updateTitle: '予約変更',
      updateServiceOrder: '列車変更 (一度だけ変更可)',
      updateParticipants: '人数変更',
      // BookingConfirm
      confirmTitle: '予約確認',
      // Payment methods
      paymentMethod: '初回支払方法/差額支払方法',
      initialPaymentMethod: '初回支払方法',
      differencePaymentMethod: '差額支払方法',
      paymentMethodNote:
        '予約時は{{count}}名を入力し、料金精算時に実際の乗車人数で計算します。',
      // dRsv01_SAI_Dsp10 F-2367/F-2368: 予約確認画面のキャンセルポリシー同意文言
      cancelNote:
        '予約をするには、<href>{{cancellationPolicy}}</href>に同意して頂く必要があります。'
    },
    bookingCreate: {
      title: '新規予約',
      copyTitle: '予約の複製',
      titleFromSeatSearch: '新規予約',
      selectAnotherServiceOrder: '第{{number}}希望を追加する',
      goToConfirm: '予約確認画面へ'
    },
    bookingUpdate: {
      title: '予約変更',
      updateServiceOrder: '列車変更 (一度だけ変更可)',
      updateParticipants: '人数変更'
    },
    bookingConfirm: {
      title: '予約確認',
      groupOrTourName: '団体名/ツアー名',
      groupOrTourNameKana: '団体名/ツアー名（ふりがな）',
      applyWaitlist: '申し込む',
      notApplyWaitlist: '申し込まない',
      // dRsv01_SAI_Dsp10 F-2367/F-2368: 予約確認画面のキャンセルポリシー同意文言
      cancelNote:
        '予約をするには、<href>{{cancellationPolicy}}</href>に同意して頂く必要があります。',
      requestBookingDialogTitle: 'リクエスト予約確認',
      requestBookingDialogMessage:
        'レストラン・食事を予約する場合は、予約詳細画面から申込みを行ってください。',
      paymentMethod: {
        coupon: '船車券（全旅）',
        couponReconciliation: '船車券洗替'
      }
    },
    bookingDetail: {
      title: '予約詳細',
      step: {
        apply: '申込',
        confirm: '確認',
        seat: '席確保',
        complete: '完了'
      },
      seatControl: '席務情報',
      seatHoldStatus: '席確保状態',
      heldQuantity: '確保席数',
      expiresAt: '有効期限',
      feeDetails: '料金詳細',
      fareResponsibleAmount: '運賃+責任人員相当分（運賃）',
      relaxResponsibleAmount: 'リラックス車両料金+責任人員相当分（料金）',
      groupOrTourName: '団体名/ツアー名',
      groupOrTourNameKana: '団体名/ツアー名（ふりがな）',
      relaxCarFee: 'リラックス車両料金',
      agentFee: '代理店手数料',
      settlementAmount: '精算額',
      firstPaymentStatus: '初回支払ステータス',
      firstPaymentMethod: '初回支払方法',
      diffPaymentStatus: '差額支払ステータス',
      diffPaymentMethod: '差額支払方法',
      cancelFee: 'キャンセル手数料',
      holdSeats: '席確保',
      holdSeatsSuccess: '席確保リクエストを送信しました。',
      holdSeatsFailed: '席確保に失敗しました。',
      releaseSeats: '席開放',
      assignSeats: '席付',
      showVoucher: '席番表（電子チケット）の表示',
      changeBooking: '予約内容変更',
      copyBooking: '予約内容の複製',
      copySuccess: '予約を複製しました。',
      copyFailed: '予約の複製に失敗しました。',
      pdfDownload: 'PDFダウンロード',
      restaurantBooking: 'レストラン・食事予約',
      cancelBooking: '予約キャンセル',
      cancelConfirmMessage: '予約をキャンセルしてもよろしいですか？',
      cancelSuccess: '予約をキャンセルしました。',
      cancelPolicyTitle: 'キャンセルポリシー同意',
      cancelPolicyMessage:
        '予約をキャンセルしますか？\n予約キャンセルには、キャンセルポリシーに同意して頂く必要があります。',
      paidAmount: '支払済',
      refundAmount: '返金額',
      comingSoon: '近日公開',
      status: '状態',
      subStatus: '子状態',
      handCloseLabel: '手仕舞ステータス',
      handCloseStatus: '手仕舞（平仓/結单）',
      handCloseLogin: '手仕舞登録',
      handCloseConfirmMessage:
        '手仕舞完了を登録します。登録後の変更はできません。よろしいですか？',
      handCloseSuccess: '手仕舞を登録しました。',
      handCloseLoginBtn: '手仕舞登録',
      undecided: '未確定',
      restaurantLabel: 'レストラン食事予約:',
      restaurantStatus: 'レストラン予約',
      tabContent: '予約内容',
      historyTitle: '予約内容受付',
      tabHistory: '変更履歴',
      historyAction: '処理',
      historyDate: '日付',
      historyDetail: 'ページ詳細',
      serviceOrderChanged: '希望班次に変更があります。',
      beforeChange: '(変更前)',
      participantChanged: '人数が変更されました: {{after}}({{before}})',
      memoDialogTitle: 'メモ編集',
      customerMemo: '予約者様 通信メモ',
      operatorMemo: '黒鉄様通信メモ',
      restaurantPresent: 'あり',
      seatTableTokenMissing:
        '席番表のアクセス情報を取得できませんでした。画面を再読み込みしてください。',
      restaurantCheckWarning: 'レストラン食事予約を確認してください。',
      restaurantCancelWarning:
        'レストラン予約があります。\nレストラン予約キャンセル画面へ遷移します。',
      feeUpdated: {
        fareTotalAmount: '運賃を更新しました。',
        relaxSeatTotalAmount: 'リラックス車両料金を更新しました。',
        agentFee: '代理店手数料を更新しました。',
        cancelFee: 'キャンセル手数料を更新しました。'
      },
      kktMemo: '黒鉄内部メモ',
      memoPlaceholder: 'メモを入力してください。',
      noMemoHistory: 'メモ履歴はありません。'
    },
    bookingSearch: {
      title: '予約検索',
      bookingOrTourNo: '予約番号・ツアー番号',
      contractAgent: '契約代理店',
      agentName: '代理店名',
      branchName: '営業所名',
      groupType: '団体区分',
      groupName: '団体名/ツアー名',
      handClose: '手仕舞',
      errorDateRangeStart: '開始日は終了日より前にしてください。',
      errorDateRangeEnd: '終了日は開始日より後にしてください。'
    },
    notificationList: {
      title: '通知一覧',
      assignee: '担当者',
      boardingDate: '乗車日',
      boardingDateTime: '乗車日時',
      groupType: '団体区分',
      groupName: '団体名',
      agencyName: '代理店名',
      branchOfficeName: '営業所名',
      personCount: '人数',
      trainName: '列車名',
      vehicleType: '車両種別',
      section: '区間',
      status: 'ステータス',
      settlementStatus: '手仕舞',
      bookingContent: '予約内容',
      receiptList: '領収書一覧',
      deleteSuccess: '通知を削除しました。',
      registerSuccess: '担当者を登録しました。',
      bookingReceivedForCustomer: '予約が受付けられました',
      modificationReceivedForCustomer: '予約変更が受付けられました',
      groupNameAndBranch: '団体名/営業所名',
      farePaymentStatus: '運賃・車両支払STS',
      fareVehicleFee: '運賃車両利用料',
      restaurantPaymentStatus: 'レストラン支払STS',
      restaurantFee: 'レストラン料金',
      differencePayment: '差額支払',
      billingPayment: '請求・支払',
      execute: '実行',
      noBillingData: '請求データがありません。',
      tabs: {
        booking: '予約',
        billing: '請求'
      }
    },
    seatReservation: {
      title: '席確保',
      statusLabel: 'ステータス',
      subStatusLabel: 'サブステータス',
      totalParticipants: '人数合計',
      personSuffix: '名',
      seatStatus: '席数／席確保状況',
      boardingPreference: '乗車希望',
      choice: '希望',
      firstChoice: '第一希望',
      secondChoice: '第二希望',
      thirdChoice: '第三希望',
      direction: '方向',
      serviceInfo: '列車情報',
      seatSuffix: '席',
      noServiceOrder: '便情報がありません。',
      statusChangeSeatCount: 'ステータス変更（席数確保）',
      seatNG: '席数確保NG',
      [SeatHoldStageEnum.SeatHold]: '席数確保',
      [SeatHoldStageEnum.SeatAssignment]: '席付',
      statusChangeSeatAssign: 'ステータス変更（席付）',
      seatAssign: '席付',
      seatChart: '席番表',
      viewChart: '参照',
      sendChart: '送付',
      sameDayRelease: '当日開放',
      sendChartDialogTitle: '席番表送付',
      sendChartDialogSubTitle: '特記事項があれば記載してください。',
      reserveSuccess: '席確保が完了しました。',
      reserveFailed: '席確保に失敗しました。',
      insufficientInventory: '在庫枠が不足しています。',
      reservePendingChangeInvalid:
        '予約変更内容を確認し、再度席数確保を実行してください。',
      reserveServiceOrderInvalid:
        '希望順位を確認し、再度席数確保を実行してください。',
      reserveActionNotAllowed: '現在の予約ステータスでは席数確保できません。',
      selectedService: '選択中のサービス',
      heldQuantity: '確保席数',
      expiresAt: '有効期限',
      // NG理由関連
      ngDialogTitle: '「席数確保NG」を確定します。',
      ngDialogSubTitle:
        '（確保済席数は開放されます）予約受付不可の理由を選択してください。',
      ngReasonTitle: '席数確保NG理由',
      ngReasonTip: 'NG理由を選択してください。',
      reason: '理由',
      ngReasons: {
        FULL: '満席',
        SERVICEDAY_SUSPENSION: '運休日',
        SERVICE_SUSPENSION: '運休',
        OTHER: 'その他'
      },
      ngReasonOtherPlaceholder: 'その他理由を入力してください。',
      ngReasonCommentRequired: 'コメントを入力してください。',
      // 確定関連
      confirmNoteTitle: '特記事項',
      confirmDialogTitle: '「{{0}}」を確定します。',
      confirmDialogSubTitle: '特記事項があれば記載してください。',
      confirmNotePlaceholder: '特記事項を入力してください。',
      confirmDialogWarning:
        '送信は一度実行すると取り消せません。送信しますか？',
      confirmPendingChangeInvalid:
        '予約変更情報を確認できません。予約内容を確認し、もう一度操作してください。',
      confirmServiceOrderMismatch:
        '選択した列車と席数確保結果が一致しません。画面を再読み込みしてやり直してください。',
      confirmHoldTargetMissing:
        '席数確保対象の列車を確認できません。席数確保をやり直してください。',
      confirmHeldQuantityInsufficient:
        '確保済みの席数が不足しています。席数確保をやり直してください。',
      resultSendConfirmationMissing:
        '席数確保の確定内容を確認できません。画面を再読み込みして、もう一度操作してください。',
      resultSendActionNotAllowed:
        '現在の予約ステータスでは予約結果を送信できません。画面を再読み込みして、予約内容を確認してください。',
      confirmResultTitle: '予約確定いたしました。',
      sendMail: '送信する',
      mailContentRequired: 'メール本文を入力してください。',
      sendMailSubject: '予約確定のお知らせ',
      releaseConfirm: '席を解放しますか？',
      releaseSuccess: '席を解放しました。',
      releaseDialogTitle: '当日開放',
      releaseDialogMessage: '席を開放しますか？'
    },
    agencyDetail: {
      title: '代理店管理',
      agentId: '代理店ID',
      agencyName: '代理店名',
      agencyNameKana: '代理店名（フリガナ）',
      faxNumber: 'FAX番号',
      phoneNumber: '電話番号',
      invoiceNumber: 'インボイス登録番号',
      representativeManager: '代表管理者',
      rootGroupMainAdminStaffName: '代表管理者所属・氏名',
      rootGroupMainAdminStaffEmail: '代表管理者メールアドレス（ログインID）',
      rootGroupMainAdminStaffTel: '代表管理者電話番号',
      accountingName: '経理担当者氏名',
      accountingEmail: '経理担当者メールアドレス',
      accountingPhone: '経理担当者電話番号',
      country: '国',
      contractType: '契約区分',
      farePaymentMethodView: '支払方法（運賃）',
      farePaymentMethodEdit: '運賃支払方法',
      monthlyBankTransfer: '月次銀振利用可',
      restaurantPaymentMethodView: '支払方法（レストラン）',
      restaurantPaymentMethodEdit: 'レストラン支払方法',
      closingDay: '月の締め日',
      paymentDay: '支払日',
      fareRebateRate: '運賃リベート率\n（船車券不使用時に適用されます）',
      boardingPeak: '乗車繁忙期',
      boardingOffPeak: '乗車閑散期',
      fareRebatePaymentMethod: '運賃リベート支払方法',
      restaurantRebateRate:
        'レストランリベート率\n（船車券不使用時に適用されます）',
      restaurantRebatePaymentMethod: 'レストランリベート支払方法',
      staffList: '代理店担当者一覧',
      agencyGroupList: '営業所一覧',
      email: 'メールアドレス',
      emailLoginId: 'メールアドレス (ログインID)',
      staffName: '担当者所属・氏名',
      language: '言語',
      permission: '権限',
      detail: '詳細',
      passwordResetEmail: 'パスワードリセットメール送信',
      agencyGroupName: '営業所名',
      managerOption: '{{name}}(代理店管理者) {{email}}',
      editStaff: '担当者を編集',
      addStaff: '担当者を新規追加',
      addAgencyGroup: '営業所を新規追加',
      addAgency: '代理店を新規追加',
      addIndividual: '個人団体を新規追加',
      agencyGroupId: '営業所ID',
      agencyGroupDetailTitle: '営業所詳細',
      agencyGroupDetailPageTitle: '営業所：詳細',
      agencyGroupStaffList: '営業所担当者一覧',
      endOfMonth: '月末',
      designatedDay: '指定日',
      agencyGroupNameKana: '営業所名（フリガナ）',
      agencyGroupEditTitle: '営業所を編集',
      fareRebateRateTitle: '運賃リベート率',
      restaurantRebateRateTitle: 'レストランリベート率',
      rebateNote: '（船車券不使用時に適用されます）',
      adminRole: '管理者',
      generalUser: '一般ユーザー',
      viewerOnly: '閲覧のみ',
      placeholder: {
        agencyGroupName: '営業所名を入力',
        agencyGroupNameKana: '営業所名（フリガナ）を入力',
        fax: 'FAX番号を入力',
        manager: '代表管理者を選択',
        email: 'メールアドレスを入力',
        staffName: '担当者所属・氏名を入力',
        phone: '電話番号を入力',
        language: '言語を選択',
        role: '権限を選択',
        invoiceNumber: 'T + 数字13桁'
      }
    },
    individualGroup: {
      list: {
        title: '個人団体一覧'
      },
      detail: {
        title: '個人団体管理',
        staffList: '個人団体担当者一覧'
      }
    },
    seatTable: {
      title: 'トロッコ列車電子乗車票',
      subtitle: '黒部峡谷トロッコ電車',
      branding: 'No1. V-shaped Gorge in Japan',
      ticketNumber: 'チケット番号',
      tourNumber: 'ツアー番号',
      direction: '方向',
      directionDown: '下り',
      directionUp: '上り',
      travelDate: '利用日',
      departureTime: '発車時間',
      serviceName: '便名',
      passengerCount: '乗車人数',
      totalLabel: '合計',
      adultCategoryLabel: '大人',
      childCategoryLabel: '小人',
      personSuffix: '名',
      seats: '座席',
      carNumber: '{{carNo}}号車',
      wheelchairSeats: '車椅子{{count}}台',
      seatsNote: '詳細は下記座席表を参照願います。',
      agencyName: '代理店名',
      branchOfficeName: '営業所名',
      groupOrTourName: '団体名/ツアー名',
      specialNotes: '特記事項',
      noSpecialNotes: 'なし',
      qrCode: 'QRコード',
      howToUse: 'チケットの利用方法',
      step01: 'こちらの乗車券をダウンロードする。',
      step02: '駅の改札にてQRコードをかざしてください。',
      step03: '座席表を確認してお座り下さい。',
      notices: '注意事項',
      notice1:
        'ホームへの入場は、出発時間の１０分前からとなります。乗車される車両の番号、位置をお確かめの上、集合場所にて改札の案内があるまで、しばらくお待ちくださいますようお願いいたします。',
      notice2:
        '変更される際は、窓口にて対応いたします。改札開始までに完了するようお願いいたします。',
      seatMapTitle: '座席表',
      seatMapNote: '※座席番号が記載されているところが選択されている座席です。'
    },
    seatAssignment: {
      title: '席付（{{direction}}）',
      back: '戻る',
      bookingNo: '予約番号・ツアー番号',
      tourInfoNo: 'ツアー番号',
      submittedDate: '申込日',
      serviceDay: '乗車日',
      groupName: '団体名/ツアー名',
      agentName: '代理店名',
      branchOfficeName: '営業所名',
      participantCount: '人数',
      wheelchairCount: '車椅子',
      trainServiceName: '便名',
      trainType: '車両種別',
      section: '区間',
      statusLabel: 'ステータス',
      personSuffix: '名',
      wheelchairSuffix: '台',
      noSeatData: '座席データがありません。',
      seatSelectHint:
        '手動設定をする場合、席を選択してください。「団体席」から選択可能です。現在確保中の席には ✓ がつきます。',
      // Legend
      legendAvailable: '選択可能',
      legendOccupied: '他予約確保済',
      legendSelected: '選択中',
      legendAssigned: '席付済み',
      // Direction
      directionDown: '往路（下り）',
      directionUp: '復路（上り）',
      // Auto setting
      autoSetting: '自動設定',
      carNoUnit: '号車',
      from: 'から',
      to: 'まで',
      total: '合計',
      seatUnit: '席',
      wheelchairUnit: '台（車椅子）',
      set: '設定',
      // Execution
      assignExecute: '席付実行',
      releaseExecute: '開放実行',
      assignedCount: '席付数',
      targetCount: '指定数',
      // Navigation
      assignOutbound: '< 往路を席付',
      assignReturn: '復路を席付 >',
      confirmOk: '席付OK',
      confirmNg: '席付NG',
      sameDayRelease: '当日開放',
      sendSeatTable: '席番表送付',
      // Success/Failure messages
      errUnsavedSeatSelection:
        '未保存の座席選択があります。席付実行後に戻ってください。',
      assignSuccess: '席付を実行しました。',
      assignFailed: '席付に失敗しました。',
      releaseSuccess: '開放を実行しました。',
      releaseFailed: '開放に失敗しました。',
      confirmOkSuccess: '席付OKを確定しました。',
      confirmNgSuccess: '席付NGを確定しました。',
      confirmFailed: '確認に失敗しました。',
      sameDayReleaseSuccess: '当日開放を実行しました。',
      sameDayReleaseFailed: '当日開放に失敗しました。',
      sendSuccess: '席番表を送付しました。',
      sendFailed: '席番表の送付に失敗しました。',
      // Send seat table dialog
      sendDialogTitle: '席番表送付',
      sendDialogSubtitle: '特記事項があれば記載してください。',
      // Confirm OK dialog
      confirmOkTitle: '「席付OK」を確定します。',
      confirmOkMessage: '特記事項があれば記載してください。',
      remarkPlaceholder: '備考を入力してください。',
      // Confirm NG dialog
      confirmNgTitle: '「席付NG」を確定します。',
      confirmNgMessage:
        '（確保済席数は開放されます）予約受付不可の理由を選択してください。',
      ngReasonLabel: 'NG理由',
      ngReasonNoSeat: '座席不足',
      ngReasonOther: 'その他',
      // Release dialog
      confirmReleaseTitle: '開放実行の確認',
      confirmReleaseMessage: '席付を開放します。よろしいですか？',
      // Same day release dialog
      confirmSameDayReleaseTitle: '当日開放の確認',
      confirmSameDayReleaseMessage: '当日開放を実行します。よろしいですか？',
      // Error messages (dRsv04_S_Dsp01_ERR001/ERR002)
      errSeatOccupied:
        '他の予約で確保されています。席を選択しなおしてください。',
      errPositiveInteger: '正の整数を入力してください。',
      errInvalidSeatLabel: '席番号の形式が正しくありません。例：1A'
    },
    dashboard: {
      title: 'ダッシュボード',
      contentsList: '記事一覧',
      contentsTitle: 'タイトル',
      contentsBody: 'コンテンツ',
      fileName: 'ファイル',
      contentActionSuccess: 'コンテンツを{{action}}しました。'
    },
    user: {
      title: {
        list: '事業者ユーザー管理',
        create: '事業者ユーザー管理',
        update: '事業者ユーザー詳細',
        detail: '事業者ユーザー詳細',
        add: '事業者ユーザー追加'
      },
      userId: 'ユーザーID',
      loginId: 'ログイン用ID',
      name: '氏名',
      nameKana: '氏名（フリガナ）',
      displayName: '担当者名',
      phone: '電話番号',
      role: '権限',
      createTime: '作成日時',
      languageCode: '言語',
      userType: 'ユーザータイプ',
      emailLoginId: 'メールアドレス(ログインID)',
      group: 'ユーザーグループ',
      sendPasswordResetEmail: 'パスワードリセットメール送信'
    },
    login: {
      email: 'メールアドレス',
      password: 'パスワード',
      loginStation: 'ログイン場所',
      signIn: 'ログイン',
      forgotPassword: 'パスワードをお忘れの場合',
      testAccount: {
        staff: '担当者',
        admin: '管理者'
      },
      tips: {
        tips1Prefix: '個別のお客様の新規登録手続きは',
        tips1Link: 'こちら',
        tips1Suffix: 'から',
        tips2:
          '旅行代理店のお客様の新規登録は弊社営業部075-xxx-xxxxまでお電話をお願いします。'
      }
    },
    password: {
      currentPassword: '現在のパスワード',
      newPassword: '新しいパスワード',
      update: {
        title: 'パスワード変更',
        successMessage: 'パスワードを変更しました。'
      },
      reset: {
        title: 'パスワード再設定',
        sendEmail: 'パスワードリセットメールを送信する',
        sendEmailSuccess:
          'パスワード再設定用のURLが{{email}}に送信されます。ご確認の上パスワードをリセットしてください。',
        sendEmailSuccessShort:
          '{{email}}にパスワードリセットメールを送信しました。'
      },
      confirm: {
        title: 'パスワードを再設定',
        newPassword: '新しいパスワード',
        changeSuccess: 'パスワードを変更しました。',
        rules: {
          title: '注記：パスワードルール',
          tips1: '最低でも8文字以上の文字数で構成されている。',
          tips2:
            'パスワードの中に数字や、「@」、「%」、「"」などの記号も混ぜている。',
          tips3:
            'パスワード内のアルファベットに大文字と小文字の両方を入れている。'
        },
        successToResetPassword: 'パスワードのリセットが成功しました。',
        backToLogin: 'ログイン画面に戻る'
      }
    },
    agency: {
      agency: '代理店名',
      email: 'メールアドレス(ログインID)',
      contactName: '担当者名',
      contactPhone: '担当者連絡先',
      placeholder: {
        agencyOfficeContactName: '代理店・営業所・担当者名'
      },
      individualBooking: '個人予約'
    }
  },
  validation: {
    requiredShort: '入力してください。',
    required: '{{name}}を入力してください。',
    invalid: '{{name}}の形式が正しくありません。',
    maxLength: '{{name}}は{{max}}文字以内で入力してください。',
    minLength: '{{name}}は{{min}}文字以上で入力してください。',
    maxNumber: '{{name}}は{{max}}以内で入力してください。',
    minNumber: '{{name}}は{{min}}以上で入力してください。',
    maxValue: '{{max}}以内の値を入力してください。',
    requiredSelect: '選択してください。',
    itemSelect: '{{name}}を選択してください。',
    requiredSelectMin: '{{min}}以上選択してください。',
    invalidInput: '有効な{{name}}を入力してください。',
    invalidEmail: '有効なメールアドレスを入力してください。',
    amountRequired: '金額を入力してください。',
    invalidFeeAmount: '8桁以内の半角数字を入力してください。',
    invalidSelect: '有効な{{name}}を選択してください。',
    participantCountMin: '{{min}}名以上でのご予約をお願いいたします。',
    caregiverExceedsDisabled: '介護者が障がい者の人数を上回っています。',
    wheelChairCountExceedsParticipants:
      '車椅子席をご利用の方の数は合計人数以下で入力してください。',
    fetchFailed: '{{name}}の取得に失敗しました。',
    invalidFirebaseLogin:
      'ログインに失敗しました。メールアドレスまたはパスワードを確認してください。',
    invalidFirebaseTenantIdMismatch:
      'ログインに失敗しました。担当者にお問い合わせください。',
    invalidUserInfo:
      'ユーザー情報が取得できませんでした。メールアドレスまたはパスワードを確認してください。',
    invoiceNumberValidation:
      'インボイス登録番号は「T」+ 数字13桁の形式で入力してください。',
    invalidPercentFormat:
      '有効なパーセント値(整数部分{{integer}}桁、小数点以下{{decimal}}桁)を入力してください。',
    userNotFound: 'ユーザーが見つかりません。再度ログインしてください。',
    userInfoNotFound: 'ユーザー情報が見つかりません。',
    duplicate: 'この{{name}}が既に登録されています。',
    number: '半角数字を入力してください。',
    invalidDateRange: '{{from}}には{{to}}以前の日付を選択してください。',
    invalidDateRangeTo: '{{to}}には{{from}}より後の日付を入力してください。',
    invalidOneYearDateRange:
      '{{from}}と{{to}}は、1年以内の範囲で指定してください。',
    cannotBeNegative: '0以上の値を入力してください。',
    cannotBeGreaterThan: '{{name}}を超える予約はできません。',
    requiredDataMissing:
      '必要な情報が取得できませんでした。画面を再読み込みして、もう一度お試しください。',
    firebase: {
      emailAlreadyInUse: 'このメールアドレスは既に登録されています。',
      wrongPassword:
        'このメールアドレスは既に登録されていますが、パスワードが間違っています。',
      invalidEmail: 'メールアドレスの形式が正しくありません。',
      operationNotAllowed: 'メール/パスワード認証が有効になっていません。',
      tooManyRequests:
        'リクエストが多すぎます。しばらく待ってから再試行してください。',
      invalidCredential: 'メールアドレスまたはパスワードが間違っています。',
      networkRequestFailed: 'ネットワークエラーが発生しました。',
      unexpectedError: 'Firebaseで予期しないエラーが発生しました。'
    },
    password: {
      invalid:
        '大文字、小文字、記号、数字を組み合わせた8文字以上で作成ください。',
      wrongPassword: '現在のパスワードが正しくありません。',
      weakPassword:
        '新しいパスワードが脆弱です。より強力なパスワードを設定してください。',
      requiresRecentLogin:
        'セキュリティのため、再度ログインしてからパスワードを変更してください。',
      userMismatch: '認証情報が一致しません。',
      userNotFound: 'ユーザーが見つかりません。',
      invalidCredential: '現在のパスワードが正しくありません。',
      failed: 'パスワードの更新に失敗しました。もう一度お試しください。'
    },
    passwordReset: {
      emailNotFound: '入力されたメールアドレスが見つかりません。',
      failed: 'メール送信に失敗しました。',
      invalidLink: '不正なリンクです。再度パスワード再設定を行ってください。',
      expiredLink:
        'リンクの有効期限が切れています。再度パスワード再設定を行ってください。'
    }
  }
};
